//#region Styles
import { 
    Container,
    ContentText } from "./styles";
//#endregion
//#region Components
import ErrorMessage from "components/ErrorMessage/ErrorMessage";
import { HelperText } from "components/styles";
//#endregion
//#region Icons
import searchIcon from "img/search_icon_purple.svg";
//#endregion

const InputButtonText = ({
    placeholder,
    text,
    onClick,
    helperText, 
    error, errorText
}) => {
    return (
        <Container>
            <div data-role="content">
                <ContentText onClick={onClick} className={error ? "error" : ""}>
                    <span className={!text ? "placeholder" : ""}>
                        {text ? text : placeholder}
                    </span>
                    <img src={searchIcon} alt="Ícono de búsqueda UTP"/>
                </ContentText>
                {helperText && <HelperText>{helperText}</HelperText>}
            </div>
            <ErrorMessage error={error} text={errorText}/>
        </Container>
    );
}

export default InputButtonText;